import { useState, useEffect } from 'react';
import { NavLink, useLocation,useNavigate } from 'react-router-dom';
import {
  CaretDoubleLeft,
  Gauge,
  Wallet,
  ArrowsLeftRight,
  Storefront,
  UsersThree,
  SignOut
} from "phosphor-react";
import { fetchUserById } from '../services/api';

const Sidebar = ({ isOpen, setIsOpen , setIsAuthenticated}) => {
  const toggleSidebar = () => setIsOpen(!isOpen);
  const location = useLocation();
  const navigate = useNavigate();
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [userData, setUserData] = useState(null);
 // ✅ READ USER FROM LOCAL STORAGE
  const user = JSON.parse(localStorage.getItem("user"));

  // ✅ GET FIRST LETTER
  const firstLetter = user?.name?.charAt(0).toUpperCase() || "";
  // ✅ LOGOUT FUNCTION 
  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('roleId');
    localStorage.removeItem('UserId');
    localStorage.removeItem('user');

    setIsAuthenticated(false);
    navigate('/login');
  };

  
  // Auto open User Management when route matches
  useEffect(() => {

    const token = localStorage.getItem("adminToken");
    const storedUserId = localStorage.getItem("userId");
    const loadUser = async () => {
      try {
        const data = await fetchUserById(storedUserId, token);
        setUserData(data);
      } catch (error) {
        console.error("Fetch user failed:", error);
        if (
          error.message.includes("Unauthenticated") ||
          error.message.includes("401")
        ) {
          localStorage.removeItem("adminToken");
          localStorage.removeItem("userId");
          localStorage.removeItem("roleId");
          navigate("/login");
        }
      }
    };
    loadUser();

    if (
      location.pathname.startsWith('/users') ||
      location.pathname.startsWith('/vendors')
    ) {
      setUserMenuOpen(true);
    }
  }, [location.pathname]);
  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className=''> 
        {/* Header with Toggle Button */}
        <div className="sidebar-header">
          <h5 className="text-xl font-500 theme-color-text">Logo</h5>
        </div>
        <div className='sidebar-profile theme-card-gery'>
          <div className='sidebar-profile-top'> 
            <div className='profie-img'>
              <span>{firstLetter}</span>
            </div>
            <button className="toggle-btn" onClick={toggleSidebar}>
              <CaretDoubleLeft />
            </button>
          </div>
          <div className='sidebar-profile-content pt-2'>
          <span className='text-xs font-400 text-uppercase theme-text-color lts-1'>
            {new Date().toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric'
            })}
          </span>
            <h2 className='text-xl font-600 theme-text-black pt-1'>Welcome back,<span className='d-block'>{user?.name}</span></h2>
          </div>
        </div>
        {/* Navigation Links */}
        <nav className="nav flex-column mt-3 gap-1 theme-card-gery sidebar-nav">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `nav-link ${isActive ? 'active-link' : 'text-opacity-75'}`
            }
          >
            {({ isActive }) => (
              <>
                <Gauge
                  size={20}
                  weight={isActive ? 'fill' : 'regular'}
                  className={isActive ? 'icon-active' : 'icon-inactive'}
                />
                <span>Dashboard</span>
              </>
            )}
          </NavLink>
          <NavLink
            to="/users"
            className={({ isActive }) =>
              `nav-link ${isActive ? 'active-link' : 'text-opacity-75'}`
            }
          >
            {({ isActive }) => (
              <>
                <UsersThree
                  size={20}
                  weight={isActive ? 'fill' : 'regular'}
                  className={isActive ? 'icon-active' : 'icon-inactive'}
                />
                <span>Users</span>
              </>
            )}
          </NavLink>

          <NavLink
            to="/vendors"
            className={({ isActive }) =>
              `nav-link ${isActive ? 'active-link' : 'text-opacity-75'}`
            }
          >
            {({ isActive }) => (
              <>
                <Storefront
                  size={20}
                  weight={isActive ? 'fill' : 'regular'}
                  className={isActive ? 'icon-active' : 'icon-inactive'}
                />
                <span>Vendors</span>
              </>
            )}
          </NavLink>

          { !userData?.aws_image_id && <NavLink
            to="/face/register"
            className={({ isActive }) => `nav-link  ${isActive ? 'active-link' : 'text-opacity-75'}`}
          >
            <Wallet  weight="fill"  /> Face Registration
          </NavLink>}
          <NavLink
            to="/wallet"
            className={({ isActive }) => `nav-link  ${isActive ? 'active-link' : 'text-opacity-75'}`}
          >
            {({ isActive }) => (
              <>
                <Wallet
                  size={20}
                  weight={isActive ? 'fill' : 'regular'}
                  className={isActive ? 'icon-active' : 'icon-inactive'}
                />
                <span>Wallet Management</span>
              </>
            )}
          </NavLink>

          <NavLink
            to="/transactions"
            className={({ isActive }) =>
              `nav-link  ${isActive ? 'active-link' : 'text-opacity-75'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <ArrowsLeftRight
                  size={20}
                  weight={isActive ? 'fill' : 'regular'}
                  className={isActive ? 'icon-active' : 'icon-inactive'}
                />
                <span>Transactions</span>
              </>
            )}
          </NavLink>
        </nav>
      </div>
     {/* ✅ LOGOUT BUTTON */}
      <div>
        <button onClick={handleLogout} className="log-btn theme-btn w-100">
          <SignOut />
          <div className='d-flex flex-column text-start'>
            <h6 className='pb-1'>Logout</h6>
            <p className='text-xs font-400'>
              Sign out securely from your account.
            </p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
